<template>
    <b-modal ref="intro-video-modal" centered id="intro-video-modal" size="lg" hide-header hide-footer class="modal-box" @hide="cleanRoute" v-if="isOpen">
      <b-container fluid>
        <b-row class="mx-5 my-5 text-center" style="justify-content: center;">
        <!-- DROPSMART LOGO -->
        <div class="text-center" >
          <img
          class="mb-5"
          :src="dropsmartLogo"
          alt="Dropsmart Logo"
          />
        </div>
          <!-- VIDEO CONTENT -->
          <DefaultVideoComponent :videoUrl="videoUrl" />
        </b-row>
      </b-container>
    </b-modal>
</template>

<script>
import DropsmartLogo from '@/assets/images/dropsmart-logo.png';
import DefaultVideoComponent from '@/components/centre/DefaultVideoComponent.vue';

export default {
  name: "IntroVideoModalComponent",
  components: {
    DefaultVideoComponent,
  },
  props: ["customerInfo"],
  mounted() {
    if(this.isOpen) {
      this.$refs['intro-video-modal'].show();
    }
  },
  data() {
    return {
      dropsmartLogo: DropsmartLogo,
      videoUrl: "https://www.youtube.com/embed/SKe9N40GL-c?rel=0",
      isOpen: false,
    };
  },
  created () {
    if(!this.closedModal() === true) {
        this.isOpen = true;
    }
  },
  methods: {
    cleanRoute() {
      this.isOpen = false;
      localStorage.setItem('intro-video-played', true);
      this.$router.push({
        name: "DropsmartCentre",
      }).catch(()=>{});
    },
    closedModal() {
      return localStorage.getItem('intro-video-played', true);
    },
  },
};
</script>
